import { Collapse, Layout } from "antd";
import { default as Icon, default as Logo } from "assets/img/icon.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routers } from "router";
const { Sider } = Layout;
const { Panel } = Collapse;

import {
  AimOutlined,
  AppstoreOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  BlockOutlined,
  CarOutlined,
  CrownOutlined,
  DashboardOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  FileDoneOutlined,
  FileImageOutlined,
  FileTextOutlined,
  FireOutlined,
  FormOutlined,
  HistoryOutlined,
  IdcardOutlined,
  InboxOutlined,
  MessageOutlined,
  MobileOutlined,
  NotificationOutlined,
  PercentageOutlined,
  PhoneOutlined,
  PictureOutlined,
  RiseOutlined,
  RocketOutlined,
  SettingOutlined,
  ShakeOutlined,
  ShopOutlined,
  SnippetsOutlined,
  StarOutlined,
  TagOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  TransactionOutlined,
  UnorderedListOutlined,
  UserOutlined,
  WalletOutlined,
  WarningOutlined,
  ZoomInOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";

export default function DashboardSider() {
  const navigate = useNavigate();
  const location = useLocation();
  // auto collapse sidebar when screen size is less than 768px
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openGroupKey, setOpenGroupKey] = useState("0");
  const { userInfo } = useSelector((state) => state.auth);

  // State quản lý các key đang mở ở từng cấp con
  const [openSubKeys, setOpenSubKeys] = useState([]);

  // Toggle mở/đóng menu con
  const handleToggleSub = (key) => {
    setOpenSubKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  // Hàm chuẩn hóa key menu thành path đầy đủ
  const joinPath = (...args) => {
    let path = args.filter(Boolean).join("/");
    if (!path.startsWith("/")) path = "/" + path;
    return path.replace(/\/+/g, "/");
  };

  // Hàm đệ quy tìm đường dẫn cha
  const findParentKeys = (items, targetKey, parents = []) => {
    for (const item of items) {
      if (item.key === targetKey) return parents;
      if (item.children) {
        const found = findParentKeys(item.children, targetKey, [
          ...parents,
          item.key,
        ]);
        if (found) return found;
      }
    }
    return null;
  };

  // Hàm kiểm tra đệ quy group có chứa key không
  const groupContainsKey = (items, targetKey) => {
    for (const item of items) {
      if (item.key === targetKey) return true;
      if (item.children && groupContainsKey(item.children, targetKey))
        return true;
    }
    return false;
  };

  const menuItems = {
    super_admin: [
      {
        label: "SUPER ADMIN",
        key: "super_admin",
        type: "group",
        children: [
          {
            key: joinPath(routers.region),
            label: "Phân cụm",
            icon: <EnvironmentOutlined />,
          },
          {
            key: joinPath(routers.superAccount),
            label: "Quản trị viên",
            icon: <CrownOutlined />,
          },
          {
            key: joinPath(routers.superWalletRequest),
            label: "Nạp - Rút ví",
            icon: <WalletOutlined />,
          },
          {
            label: "Thiết lập chung",
            key: joinPath(routers.superSetup.index),
            icon: <SettingOutlined />,
            children: [
              {
                label: "Hệ thống",
                key: joinPath(
                  routers.superSetup.index,
                  routers.superSetup.system
                ),
                icon: <ToolOutlined />,
              },
              {
                label: "Map Service",
                key: joinPath(
                  routers.superSetup.index,
                  routers.superSetup.mapService
                ),
                icon: <EnvironmentOutlined />,
              },
              {
                label: "Voucher đặt 1 đơn",
                key: joinPath(
                  routers.superSetup.index,
                  routers.superSetup.event
                ),
                icon: <TagOutlined />,
              },
            ],
          },
          {
            label: "Thống kê",
            key: joinPath(routers.superStats.index),
            icon: <AreaChartOutlined />,
            children: [
              {
                label: "OTP",
                key: joinPath(routers.superStats.index, routers.superStats.otp),
                icon: <ShakeOutlined />,
              },
              {
                label: "Email",
                key: joinPath(
                  routers.superStats.index,
                  routers.superStats.email
                ),
                icon: <InboxOutlined />,
              },
              {
                label: "Map Request",
                key: joinPath(
                  routers.superStats.index,
                  routers.superStats.mapRequest
                ),
                icon: <EnvironmentOutlined />,
              },
            ],
          },
        ],
      },
      {
        type: "divider",
        style: {
          borderColor: "inherit",
          margin: "12px 24px",
        },
      },
      {
        key: "food",
        label: "GOKA FOOD",
        type: "group",
        children: [
          {
            label: "Dashboard",
            key: joinPath(routers.dashboard),
            icon: <DashboardOutlined />,
          },
          {
            label: "Đơn hàng",
            key: joinPath(routers.food.index, routers.food.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
          {
            label: "Danh mục đồ ăn",
            key: joinPath(routers.category),
            icon: <InboxOutlined />,
          },
          {
            label: "Nhà hàng",
            key: joinPath(routers.restaurant),
            icon: <ShopOutlined />,
          },
          {
            label: "Chiến dịch",
            key: joinPath(routers.campaign),
            icon: <RiseOutlined />,
          },
          {
            label: "Flash Sale",
            key: joinPath(routers.flashSale),
            icon: <ThunderboltOutlined />,
          },
          {
            label: "Nhãn quán",
            key: joinPath(routers.restaurantLabel),
            icon: <FileImageOutlined />,
          },
          {
            label: "Bộ sưu tập",
            key: joinPath(routers.collection),
            icon: <AppstoreOutlined />,
          },

          {
            label: "Quảng cáo",
            key: joinPath(routers.ad.index),
            icon: <FireOutlined />,
            children: [
              {
                label: "Danh sách",
                key: joinPath(routers.ad.index, routers.ad.list),
                icon: <RocketOutlined />,
              },
              {
                label: "Loại hình",
                key: joinPath(routers.ad.index, routers.ad.type),
                icon: <BlockOutlined />,
              },
            ],
          },
          {
            label: "Voucher",
            key: joinPath(routers.voucher),
            icon: <TagOutlined />,
          },
          {
            label: "Hợp đồng",
            key: joinPath(routers.restaurantContract),
            icon: <FileTextOutlined />,
          },
          {
            label: "Căn cước công dân",
            key: joinPath(routers.restaurantIdentity),
            icon: <IdcardOutlined />,
          },
          {
            label: "Thiết lập",
            key: joinPath(routers.food.index, routers.food.setup.index),
            icon: <SettingOutlined />,
            children: [
              {
                label: "Phí - Chiết khấu",
                key: joinPath(
                  routers.food.index,
                  routers.food.setup.index,
                  routers.food.setup.feeCharge
                ),
                icon: <PercentageOutlined />,
              },
              {
                label: "Từ khóa nổi bật",
                key: joinPath(
                  routers.food.index,
                  routers.food.setup.index,
                  routers.food.setup.hotKeyword
                ),
                icon: <ZoomInOutlined />,
              },
              {
                label: "Quán bị hạn chế",
                key: joinPath(
                  routers.food.index,
                  routers.food.setup.index,
                  routers.food.setup.blackRestaurants
                ),
                icon: <WarningOutlined />,
              },
            ],
          },
          {
            label: "Báo cáo",
            key: joinPath(routers.report.index),
            icon: <BarChartOutlined />,
            children: [
              {
                label: "Doanh thu nhà hàng",
                key: joinPath(
                  routers.report.index,
                  routers.report.restaurantRevenue
                ),
                icon: <DollarOutlined />,
              },
            ],
          },
        ],
      },
      {
        key: joinPath(routers.bike.index),
        label: "GOKA BIKE",
        type: "group",
        children: [
          {
            label: "Dashboard",
            key: joinPath(routers.bike.index, routers.bike.dashboard),
            icon: <DashboardOutlined />,
          },
          {
            label: "Đơn hàng",
            key: joinPath(routers.bike.index, routers.bike.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
          {
            label: "Địa điểm gợi ý",
            key: joinPath(routers.bike.index, routers.bike.place),
            icon: <EnvironmentOutlined />,
          },
          {
            label: "Gói tiết kiệm",
            key: joinPath(routers.bike.index, routers.bike.combo),
            icon: <AppstoreOutlined />,
          },
          {
            label: "Lịch sử mua gói",
            key: joinPath(routers.bike.index, routers.bike.comboTransaction),
            icon: <FileDoneOutlined />,
          },
          {
            label: "Voucher",
            key: joinPath(routers.bike.index, routers.bike.voucher),
            icon: <TagOutlined />,
          },
          {
            label: "Thiết lập",
            key: joinPath(routers.bike.index, routers.bike.setup.index),
            icon: <SettingOutlined />,
            children: [
              {
                label: "Phí - Chiết khấu",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.setup.index,
                  routers.bike.setup.feeCharge
                ),
                icon: <PercentageOutlined />,
              },
            ],
          },
        ],
      },
      {
        key: joinPath(routers.express.index),
        label: "GOKA GIAO HÀNG",
        type: "group",
        children: [
          {
            label: "Dashboard",
            key: joinPath(routers.express.index, routers.express.dashboard),
            icon: <DashboardOutlined />,
          },
          {
            label: "Đơn hàng",
            key: joinPath(routers.express.index, routers.express.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
          {
            label: "Gói tiết kiệm",
            key: joinPath(routers.express.index, routers.express.combo),
            icon: <AppstoreOutlined />,
          },
          {
            label: "Lịch sử mua gói",
            key: joinPath(
              routers.express.index,
              routers.express.comboTransaction
            ),
            icon: <FileDoneOutlined />,
          },
          {
            label: "Voucher",
            key: joinPath(routers.express.index, routers.express.voucher),
            icon: <TagOutlined />,
          },
          {
            label: "Thiết lập",
            key: joinPath(routers.express.index, routers.express.setup.index),
            icon: <SettingOutlined />,
            children: [
              {
                label: "Phí - Chiết khấu",
                key: joinPath(
                  routers.express.index,
                  routers.express.setup.index,
                  routers.express.setup.feeCharge
                ),
                icon: <PercentageOutlined />,
              },
            ],
          },
        ],
      },
      {
        key: joinPath(routers.driver.index),
        label: "GOKA BSTL",
        type: "group",
        children: [
          {
            label: "Dashboard",
            key: joinPath(routers.driver.index, routers.driver.dashboard),
            icon: <DashboardOutlined />,
          },
          {
            label: "Đơn hàng",
            key: joinPath(routers.driver.index, routers.driver.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.driver.index,
                  routers.driver.order.index,
                  routers.driver.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.driver.index,
                  routers.driver.order.index,
                  routers.driver.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.driver.index,
                  routers.driver.order.index,
                  routers.driver.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
          {
            label: "Voucher",
            key: joinPath(routers.driver.index, routers.driver.voucher),
            icon: <TagOutlined />,
          },
          {
            label: "Thiết lập",
            key: joinPath(routers.driver.index, routers.driver.setup.index),
            icon: <SettingOutlined />,
            children: [
              {
                label: "Phí - Chiết khấu",
                key: joinPath(
                  routers.driver.index,
                  routers.driver.setup.index,
                  routers.driver.setup.feeCharge
                ),
                icon: <PercentageOutlined />,
              },
            ],
          },
        ],
      },
      {
        type: "divider",
        style: {
          borderColor: "inherit",
          margin: "12px 24px",
        },
      },
      {
        label: "Tài xế",
        key: joinPath(routers.shipper.index),
        icon: <CarOutlined />,
        children: [
          {
            label: "Danh sách",
            key: joinPath(routers.shipper.index, routers.shipper.list),
            icon: <UnorderedListOutlined />,
          },
          {
            label: "Vị trí",
            key: joinPath(routers.shipper.index, routers.shipper.map),
            icon: <AimOutlined />,
          },
        ],
      },
      {
        label: "Người dùng",
        key: joinPath(routers.user),
        icon: <UserOutlined />,
      },
      {
        label: "Banner",
        key: joinPath(routers.banner.index),
        icon: <PictureOutlined />,
        children: [
          {
            label: "App user",
            key: joinPath(routers.banner.index, routers.banner.user),
            icon: <MobileOutlined />,
          },
          {
            label: "App quán",
            key: joinPath(routers.banner.index, routers.banner.merchant),
            icon: <ShopOutlined />,
          },
        ],
      },
      {
        label: "Thông báo",
        key: joinPath(routers.notification),
        icon: <NotificationOutlined />,
      },
      {
        label: "Hòm thư",
        key: joinPath(routers.message),
        icon: <MessageOutlined />,
      },
      {
        label: "Đánh giá",
        key: joinPath(routers.review.index),
        icon: <StarOutlined />,
        children: [
          {
            label: "Nhà hàng",
            key: joinPath(routers.review.index, routers.review.restaurant),
            icon: <ShopOutlined />,
          },
          {
            label: "Tài xế",
            key: joinPath(routers.review.index, routers.review.shipper),
            icon: <CarOutlined />,
          },
        ],
      },
      {
        label: "Liên hệ",
        key: joinPath(routers.contact),
        icon: <PhoneOutlined />,
      },
      {
        label: "Lệnh nạp - rút ví",
        key: joinPath(routers.walletRequest),
        icon: <TransactionOutlined />,
      },
      {
        label: "Số dư ví",
        key: joinPath(routers.wallet),
        icon: <WalletOutlined />,
      },
      {
        label: "Tài khoản",
        key: joinPath(routers.account),
        icon: <UserOutlined />,
      },
      {
        label: "Thiết lập chung",
        key: joinPath(routers.setup.index),
        icon: <SettingOutlined />,
        children: [
          {
            label: "Hệ thống",
            key: joinPath(routers.setup.index, routers.setup.system),
            icon: <ToolOutlined />,
          },
          {
            label: "Thưởng tài xế",
            key: joinPath(routers.setup.index, routers.setup.rewards),
            icon: <DollarOutlined />,
          },
        ],
      },
    ],
    admin: [],
    customer_service: [
      {
        key: "food",
        label: "GOKA FOOD",
        type: "group",
        children: [
          {
            label: "Đơn hàng",
            key: joinPath(routers.food.index, routers.food.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
        ],
      },
      {
        key: joinPath(routers.bike.index),
        label: "GOKA BIKE",
        type: "group",
        children: [
          {
            label: "Đơn hàng",
            key: joinPath(routers.bike.index, routers.bike.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
        ],
      },
      {
        key: joinPath(routers.express.index),
        label: "GOKA EXPRESS",
        type: "group",
        children: [
          {
            label: "Đơn hàng",
            key: joinPath(routers.express.index, routers.express.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
        ],
      },
      {
        key: joinPath(routers.driver.index),
        label: "GOKA BSTL",
        type: "group",
        children: [
          {
            label: "Đơn hàng",
            key: joinPath(routers.driver.index, routers.driver.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.driver.index,
                  routers.driver.order.index,
                  routers.driver.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.driver.index,
                  routers.driver.order.index,
                  routers.driver.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.driver.index,
                  routers.driver.order.index,
                  routers.driver.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
        ],
      },
      {
        type: "divider",
        style: {
          borderColor: "inherit",
          margin: "12px 24px",
        },
      },
      {
        label: "Tài xế",
        key: joinPath(routers.shipper.index),
        icon: <CarOutlined />,
        children: [
          {
            label: "Danh sách",
            key: joinPath(routers.shipper.index, routers.shipper.list),
            icon: <UnorderedListOutlined />,
          },
          {
            label: "Vị trí",
            key: joinPath(routers.shipper.index, routers.shipper.map),
            icon: <AimOutlined />,
          },
        ],
      },
      {
        label: "Đánh giá",
        key: joinPath(routers.review.index),
        icon: <StarOutlined />,
        children: [
          {
            label: "Nhà hàng",
            key: joinPath(routers.review.index, routers.review.restaurant),
            icon: <ShopOutlined />,
          },
          {
            label: "Tài xế",
            key: joinPath(routers.review.index, routers.review.shipper),
            icon: <CarOutlined />,
          },
        ],
      },
    ],
    manager: [
      {
        key: "food",
        label: "GOKA FOOD",
        type: "group",
        children: [
          {
            label: "Đơn hàng",
            key: joinPath(routers.food.index, routers.food.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.food.index,
                  routers.food.order.index,
                  routers.food.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
          {
            label: "Nhà hàng",
            key: joinPath(routers.restaurant),
            icon: <ShopOutlined />,
          },
          {
            label: "Voucher",
            key: joinPath(routers.voucher),
            icon: <TagOutlined />,
          },
        ],
      },
      {
        key: joinPath(routers.bike.index),
        label: "GOKA BIKE",
        type: "group",
        children: [
          {
            label: "Đơn hàng",
            key: joinPath(routers.bike.index, routers.bike.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.bike.index,
                  routers.bike.order.index,
                  routers.bike.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
          {
            label: "Voucher",
            key: joinPath(routers.bike.index, routers.bike.voucher),
            icon: <TagOutlined />,
          },
        ],
      },
      {
        key: joinPath(routers.express.index),
        label: "GOKA EXPRESS",
        type: "group",
        children: [
          {
            label: "Đơn hàng",
            key: joinPath(routers.express.index, routers.express.order.index),
            icon: <FormOutlined />,
            children: [
              {
                label: "Trực tiếp",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.live
                ),
                icon: <ThunderboltOutlined />,
              },
              {
                label: "Đang xử lý",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.new
                ),
                icon: <SnippetsOutlined />,
              },
              {
                label: "Lịch sử",
                key: joinPath(
                  routers.express.index,
                  routers.express.order.index,
                  routers.express.order.history
                ),
                icon: <HistoryOutlined />,
              },
            ],
          },
          {
            label: "Voucher",
            key: joinPath(routers.express.index, routers.express.voucher),
            icon: <TagOutlined />,
          },
        ],
      },
      // {
      //   key: joinPath(routers.driver.index),
      //   label: "GOKA BSTL",
      //   type: "group",
      //   children: [
      //     {
      //       label: "Đơn hàng",
      //       key: joinPath(routers.driver.index, routers.driver.order.index),
      //       icon: <FormOutlined />,
      //       children: [
      //         {
      //           label: "Trực tiếp",
      //           key: joinPath(routers.driver.index, routers.driver.order.index, routers.driver.order.live),
      //           icon: <ThunderboltOutlined />,
      //         },
      //         {
      //           label: "Đang xử lý",
      //           key: joinPath(routers.driver.index, routers.driver.order.index, routers.driver.order.new),
      //           icon: <SnippetsOutlined />,
      //         },
      //         {
      //           label: "Lịch sử",
      //           key: joinPath(routers.driver.index, routers.driver.order.index, routers.driver.order.history),
      //           icon: <HistoryOutlined />,
      //         },
      //       ],
      //     },
      //     {
      //       label: "Voucher",
      //       key: joinPath(routers.driver.index, routers.driver.voucher),
      //       icon: <TagOutlined />,
      //     },
      //   ],
      // },
      {
        type: "divider",
        style: {
          borderColor: "inherit",
          margin: "12px 24px",
        },
      },
      {
        label: "Tài xế",
        key: joinPath(routers.shipper.index),
        icon: <CarOutlined />,
        children: [
          {
            label: "Danh sách",
            key: joinPath(routers.shipper.index, routers.shipper.list),
            icon: <UnorderedListOutlined />,
          },
          {
            label: "Vị trí",
            key: joinPath(routers.shipper.index, routers.shipper.map),
            icon: <AimOutlined />,
          },
        ],
      },
      {
        label: "Người dùng",
        key: joinPath(routers.user),
        icon: <UserOutlined />,
      },
      {
        label: "Đánh giá",
        key: joinPath(routers.review.index),
        icon: <StarOutlined />,
        children: [
          {
            label: "Nhà hàng",
            key: joinPath(routers.review.index, routers.review.restaurant),
            icon: <ShopOutlined />,
          },
          {
            label: "Tài xế",
            key: joinPath(routers.review.index, routers.review.shipper),
            icon: <CarOutlined />,
          },
        ],
      },
    ],
  };

  menuItems.admin = menuItems.super_admin.slice(2);

  useEffect(() => {
    setSelectedKeys([location.pathname]);
    // Tìm group chứa item đang active
    const groups = menuItems[userInfo.role].filter(
      (item) => item.type === "group"
    );
    const others = menuItems[userInfo.role].filter(
      (item) => item.type !== "group" && item.type !== "divider"
    );
    const allGroups = [
      ...groups,
      others.length > 0
        ? {
            label: "KHÁC",
            key: "other_group",
            type: "group",
            children: others,
          }
        : null,
    ].filter(Boolean);
    let foundGroupIdx = "0";
    let parentKeys = [];
    allGroups.forEach((group, idx) => {
      if (groupContainsKey(group.children, location.pathname)) {
        foundGroupIdx = String(idx);
      }
      // Tìm các key cha cần mở
      const found = findParentKeys(group.children, location.pathname);
      if (found) {
        parentKeys = found;
      }
    });
    setOpenGroupKey(foundGroupIdx);
    setOpenSubKeys(parentKeys);
  }, [location, userInfo.role]);

  const onSelectMenuItem = (item) => {
    setSelectedKeys([item.key]);
    navigate(item.key);
  };

  // Đệ quy render menu nhiều cấp
  const renderMenuItems = (items, level = 0) => {
    return items.map((item) => {
      const isActive = selectedKeys[0] === item.key;
      const isOpen = openSubKeys.includes(item.key);
      if (item.children && item.children.length > 0) {
        return (
          <div key={item.key}>
            <div
              style={{
                padding: "8px 24px",
                color: isActive ? "#1677ff" : "#fff",
                fontWeight: isActive ? 600 : 400,
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
                marginLeft: level * 16,
                userSelect: "none",
                background: isActive ? "#e6f4ff" : "#001c37",
                borderRadius: 4,
                marginBottom: 4,
              }}
              onClick={() => handleToggleSub(item.key)}
            >
              {item.icon} {item.label}
              <span style={{ marginLeft: "auto", fontSize: 12 }}>
                {isOpen ? "▼" : "▶"}
              </span>
            </div>
            {isOpen && (
              <div style={{ marginLeft: 16 }}>
                {renderMenuItems(item.children, level + 1)}
              </div>
            )}
          </div>
        );
      }
      return (
        <div
          key={item.key}
          style={{
            padding: "8px 24px",
            color: isActive ? "#1677ff" : "#fff",
            cursor: "pointer",
            borderRadius: 4,
            marginBottom: 4,
            background: isActive ? "#e6f4ff" : "#001c37",
            fontWeight: isActive ? 600 : 400,
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginLeft: level * 16,
          }}
          onClick={() => {
            setSelectedKeys([item.key]);
            navigate(item.key);
          }}
        >
          {item.icon} {item.label}
        </div>
      );
    });
  };

  // Custom render cho group menu bằng Collapse cho tất cả group
  const renderCustomMenu = () => {
    // Lấy tất cả group (type: "group")
    const groups = menuItems[userInfo.role].filter(
      (item) => item.type === "group"
    );
    // Các mục lẻ (không phải group, không phải divider)
    const others = menuItems[userInfo.role].filter(
      (item) => item.type !== "group" && item.type !== "divider"
    );
    // Divider
    const dividers = menuItems[userInfo.role].filter(
      (item) => item.type === "divider"
    );
    // Gom các mục lẻ thành 1 group "KHÁC"
    const allGroups = [
      ...groups,
      others.length > 0
        ? {
            label: "KHÁC",
            key: "other_group",
            type: "group",
            children: others,
          }
        : null,
    ].filter(Boolean);
    return (
      <>
        <Collapse
          bordered={false}
          defaultActiveKey={["0"]}
          expandIconPosition="right"
          accordion
          activeKey={openGroupKey}
          onChange={(key) => setOpenGroupKey(key)}
          style={{ background: "#001529", color: "#fff" }}
        >
          {allGroups.map((group, idx) => (
            <Panel
              header={
                <span
                  style={{
                    color: "#FFD22F",
                    fontWeight: 700,
                    paddingLeft: 12,
                    borderLeft: "4px solid #FFD22F",
                    display: "block",
                  }}
                >
                  {group.label}
                </span>
              }
              key={idx}
              style={{ border: 0 }}
            >
              {renderMenuItems(group.children)}
            </Panel>
          ))}
        </Collapse>
        {/* Divider nếu có */}
        {/* {dividers.map((item, idx) => (
          <div
            key={`divider-${idx}`}
            style={{
              borderTop: "1px solid #333",
              margin: "12px 24px",
              opacity: 0.5,
            }}
          />
        ))} */}
      </>
    );
  };

  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        className="overflow-auto h-screen !sticky inset-0"
        width={250}
      >
        <div className="p-4" style={{ textAlign: "center" }}>
          <img
            src={collapsed ? Icon : Logo}
            alt="logo"
            className="w-full"
            style={{ width: "100px" }}
          />
        </div>
        {/* Custom menu bằng Collapse cho tất cả group */}
        {renderCustomMenu()}
        {/* <Menu ... /> đã bị loại bỏ */}
      </Sider>
    </>
  );
}
